import { render, staticRenderFns } from "./MessageTemplatesUpdate.vue?vue&type=template&id=36a54b00&scoped=true"
import script from "./MessageTemplatesUpdate.vue?vue&type=script&lang=js"
export * from "./MessageTemplatesUpdate.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplatesUpdate.vue?vue&type=style&index=0&id=36a54b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a54b00",
  null
  
)

export default component.exports